/*
 * Public API Surface of addon-material
 */

export * from './user-management/user-management.component';
export * from './user-management-setup/user-management-setup.component';
export * from './user-management.module';
